import {createApp} from 'vue'
import {createStore} from 'vuex'
import App from './App.vue'
import {createRouter, createWebHashHistory} from 'vue-router'
import LoginComponent from '@/LoginPage'
import EmployeePage from '@/EmployeePage'
import EmployeeThanksPage from '@/EmployeeThanks'
import EmployerPage from '@/EmployerPage'
import HistoryPage from '@/HistoryPage'
import HistoryOwnPage from '@/HistoryOwnPage'
import ProductsComponent from '@/ProductsComponent'
import ThanksPage from '@/ThanksPage'
import StatsPage from '@/StatsPage'
import ProfileComponent from '@/ProfilePage'
import LoadScript from "vue-plugin-load-script";
import axios from 'axios'

const routes = [
    {path: '/login', component: LoginComponent},
    {path: '/profile', component: ProfileComponent},
    {path: '/products', component: ProductsComponent},
    {path: '/employee', component: EmployeePage},
    {path: '/employeeThanks', component: EmployeeThanksPage},
    {path: '/employer', component: EmployerPage},
    {path: '/thanks', component: ThanksPage},
    {path: '/stats', component: StatsPage},
    {path: '/history', component: HistoryPage},
    {path: '/historyOwn', component: HistoryOwnPage},
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

const baseUrl = process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:9090'

const getHeaders = () => {
    const headers = {}
    if (localStorage.getItem('phone') !== null) {
        headers['Authorization'] = `Basic ${btoa(localStorage.getItem('phone') + ':' + localStorage.getItem('token'))}`
        headers['Content-Type'] = 'application/json'
    }
    return headers
}

const store = createStore({
    state() {
        return {
            count: 0,
            from: null,
            to: null,
            orders: [],
            employee: [],
            thanks: [],
            thanksOwn: [],
            profile: null,
            gifts: [],
            stats: {
                worth: [],
                empployee: []
            },
            values: [
                {
                    id: 1,
                    name: 'Инициатива/эффективность',
                    description: 'Наши действия ориентированы на результат, оптимизацию процессов и поиск новых путей совершенствования сервиса и работы. Мы действуем по собственной инициативе, осознавая ответственность за успех всей компании.',
                    conditions: [
                        'Эффективные идеи, предложения',
                        'Способность достигать высоких результатов, активнось',
                        'Проактивный подход в работе, инициативу и самостоятельность в решении сложных вопросов'
                    ],
                    icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>human-greeting-variant</title><path fill="green" d="M1.5,4V5.5C1.5,9.65 3.71,13.28 7,15.3V20H22V18C22,15.34 16.67,14 14,14C14,14 13.83,14 13.75,14C9,14 5,10 5,5.5V4M14,4A4,4 0 0,0 10,8A4,4 0 0,0 14,12A4,4 0 0,0 18,8A4,4 0 0,0 14,4Z" /></svg>',
                    color: 'red'
                },
                {
                    id: 2,
                    name: 'Забота и поддержка',
                    description: 'Мы с заботой, теплотой и вниманием относимся к пациентам и коллегам. Всегда готовы помочь. В интересах здоровья. Действуем, превосходя ожидания.',
                    conditions: [
                        'За сервисную историю "превосходя ожидания" (в т.ч. благодарности от пациентов)',
                        'Внимательное отношение к коллегам и пациентам, искреннее желание помочь',
                        'Отзывчивость и взаимопомощь (внеплановый выход на другой филиал и др.)'
                    ],
                    icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>heart-flash</title><path fill="orange" d="M16.5,2.83C14.76,2.83 13.09,3.64 12,4.9C10.91,3.64 9.24,2.83 7.5,2.83C4.42,2.83 2,5.24 2,8.33C2,12.1 5.4,15.19 10.55,19.86L12,21.17L13.45,19.86C18.6,15.19 22,12.1 22,8.33C22,5.24 19.58,2.83 16.5,2.83M12,17.83V13.83H9L12,6.83V10.83H15" /></svg>',
                    color: 'yellow'
                },
                {
                    id: 3,
                    name: 'Ответственность',
                    description: 'Мы с ответственностью относимся к своей деятельности, принимая во внимание интересы сотрудников и пациентов.',
                    conditions: [
                        'Надежность, обязательность в выполнении задач',
                        'Желание и умение брать на себя ответственность за блок работы'
                    ],
                    icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>book-clock-outline</title><path fill="blue" d="M20 11.26V4C20 2.9 19.11 2 18 2H6C4.89 2 4 2.9 4 4V20C4 21.11 4.89 22 6 22H11.11C12.37 23.24 14.09 24 16 24C19.87 24 23 20.87 23 17C23 14.62 21.81 12.53 20 11.26M18 4V10.29C17.37 10.11 16.7 10 16 10C14.93 10 13.91 10.25 13 10.68V4H18M6 4H8V12L10.5 9.75L12.1 11.19C10.23 12.45 9 14.58 9 17C9 18.08 9.25 19.09 9.68 20H6V4M16 22C13.24 22 11 19.76 11 17S13.24 12 16 12 21 14.24 21 17 18.76 22 16 22M16.5 17.25L19.36 18.94L18.61 20.16L15 18V13H16.5V17.25Z" /></svg>',
                    color: 'blue'
                },
                {
                    id: 4,
                    name: 'Вовлеченность',
                    description: 'Мы занимаемся любимым делом, это безумный драйв 24/7. Мы активно и безвозмездно делимся своим креативом, принимаем участие в жизни Садко, в мероприятиях и проектах компании.',
                    conditions: [
                        'Помощь в экстремальных ситуациях (неотложные состояния, аварийные ситуации)',
                        'Помощь в закрытии вакансий "Приведи друга"',
                        'Отзыв о враче, клинике от сотрудника на внешних ресурсах',
                        'Участие в мероприятиях компании и помощь в организации'
                    ],
                    icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>check-all</title><path fill="red" d="M0.41,13.41L6,19L7.41,17.58L1.83,12M22.24,5.58L11.66,16.17L7.5,12L6.07,13.41L11.66,19L23.66,7M18,7L16.59,5.58L10.24,11.93L11.66,13.34L18,7Z" /></svg>',
                    color: 'orange'
                },
                {
                    id: 5,
                    name: 'Честность/открытость',
                    description: 'Мы рассатриваем коммуникации как открытое и честное обсуждение. Нам важно, чтобы наши сотрудники чувствовали себя в безопасности, открыто обсуждали идеи по улучшению и активно учавствовали в процессе принятия решений.',
                    conditions: [
                        'Свободное общение вне иерархических рамок',
                        'Честный обмен мнениями, за возможность посоветоваться, когда что-то идет не по плану'
                    ],
                    icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>account-switch</title><path fill="purple" d="M16 9C22 9 22 13 22 13V15H16V13C16 13 16 11.31 14.85 9.8C14.68 9.57 14.47 9.35 14.25 9.14C14.77 9.06 15.34 9 16 9M2 13C2 13 2 9 8 9S14 13 14 13V15H2V13M9 17V19H15V17L18 20L15 23V21H9V23L6 20L9 17M8 1C6.34 1 5 2.34 5 4S6.34 7 8 7 11 5.66 11 4 9.66 1 8 1M16 1C14.34 1 13 2.34 13 4S14.34 7 16 7 19 5.66 19 4 17.66 1 16 1Z" /></svg>',
                    color: 'green'
                },
                {
                    id: 6,
                    name: 'Развитие/обучение',
                    description: 'Садко - это команда профессионалов-единомышленников, постоянно стремящихся к развитию. Мы стремимся вперед и с каждым годом набираем высоту.',
                    conditions: [
                        'Наставничество (эффективное обучение новичков)',
                        'Саморазвитие сотрудника и повышение своей квалификации',
                        'Выступление, доклад на любом мероприятии'
                    ],
                    icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>account-school</title><path fill="currentColor" d="M16 8C16 10.21 14.21 12 12 12C9.79 12 8 10.21 8 8L8.11 7.06L5 5.5L12 2L19 5.5V10.5H18V6L15.89 7.06L16 8M12 14C16.42 14 20 15.79 20 18V20H4V18C4 15.79 7.58 14 12 14Z" /></svg>',
                    color: 'gray'
                },
                {
                    id: 7,
                    name: 'Креатив/творчество/нестандартные идеи',
                    description: 'Мы ориентированы на поиск новых нестандартных и оптимальных путей решения задач, нестандартный выход из сложных ситуаций, которые приводят к очевидным плодотворным последствиям. Креатив, творчество и эксклюзивные идеи - это драйв, инновации и основа развития сети клиник «Садко».',
                    conditions: [
                        'Нестандартные идеи, применимые в работе',
                        'Активное участие в проектных командах и мозговых штурмах с предложениями',
                        'Проявление творчества и креатива'
                    ],
                    icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>lightbulb-on-20</title><path fill="currentColor" d="M1 11H4V13H1V11M4.9 3.5L3.5 4.9L5.6 7L7 5.6L4.9 3.5M13 1H11V4H13V1M20 11V13H23V11H20M10 22C10 22.6 10.4 23 11 23H13C13.6 23 14 22.6 14 22V21H10V22M19.1 3.5L17 5.6L18.4 7L20.5 4.9L19.1 3.5M18 12C18 14.2 16.8 16.2 15 17.2V19C15 19.6 14.6 20 14 20H10C9.4 20 9 19.6 9 19V17.2C7.2 16.2 6 14.2 6 12C6 8.7 8.7 6 12 6S18 8.7 18 12M16 12C16 9.79 14.21 8 12 8S8 9.79 8 12 9.79 16 12 16 16 14.21 16 12Z" /></svg>',
                    color: 'pink'
                },
                {
                    id: 998,
                    name: 'Бонусы/Активити',
                    description: '',
                    conditions: [],
                    icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>lightbulb-on-20</title><path fill="currentColor" d="M1 11H4V13H1V11M4.9 3.5L3.5 4.9L5.6 7L7 5.6L4.9 3.5M13 1H11V4H13V1M20 11V13H23V11H20M10 22C10 22.6 10.4 23 11 23H13C13.6 23 14 22.6 14 22V21H10V22M19.1 3.5L17 5.6L18.4 7L20.5 4.9L19.1 3.5M18 12C18 14.2 16.8 16.2 15 17.2V19C15 19.6 14.6 20 14 20H10C9.4 20 9 19.6 9 19V17.2C7.2 16.2 6 14.2 6 12C6 8.7 8.7 6 12 6S18 8.7 18 12M16 12C16 9.79 14.21 8 12 8S8 9.79 8 12 9.79 16 12 16 16 14.21 16 12Z" /></svg>',
                    color: 'gray'
                },
                {
                    id: 998,
                    name: 'Исключительная благодарность',
                    description: '',
                    conditions: [],
                    icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>lightbulb-on-20</title><path fill="currentColor" d="M1 11H4V13H1V11M4.9 3.5L3.5 4.9L5.6 7L7 5.6L4.9 3.5M13 1H11V4H13V1M20 11V13H23V11H20M10 22C10 22.6 10.4 23 11 23H13C13.6 23 14 22.6 14 22V21H10V22M19.1 3.5L17 5.6L18.4 7L20.5 4.9L19.1 3.5M18 12C18 14.2 16.8 16.2 15 17.2V19C15 19.6 14.6 20 14 20H10C9.4 20 9 19.6 9 19V17.2C7.2 16.2 6 14.2 6 12C6 8.7 8.7 6 12 6S18 8.7 18 12M16 12C16 9.79 14.21 8 12 8S8 9.79 8 12 9.79 16 12 16 16 14.21 16 12Z" /></svg>',
                    color: 'gray'
                }
            ]
        }
    },
    getters: {
        amount(state) {
            return state.to.reduce((a, b) => a + b.count, 0) - state.orders.reduce((a, b) => a + b.amount, 0)
        },
        orders(state) {
            return state.orders
        },
        values(state) {
            return state.values
        },
        stats(state) {
            return state.stats
        },
        gifts(state) {
            return state.gifts
        },
        from(state) {
            return state.from
        },
        to(state) {
            return state.to
        },
        fromCount(state) {
            return state.from.reduce((a, b) => a + b.count, 0)
        },
        toCount(state) {
            return state.to.reduce((a, b) => a + b.count, 0)
        },
        thanks(state) {
            return state.thanks
        },
        thanksOwn(state) {
            return state.thanksOwn
        },
        profile(state) {
            return state.profile
        },
        groups(state) {
            if (state.profile === null) return []
            return state.profile.groups
        },
        tasks(state) {
            if (state.profile === null) return []
            return state.profile.tasks
        },
        products(state) {
            if (state.profile === null) return []
            return state.profile.products
        },
        history(state) {
            if (state.profile === null) return []
            return state.profile.history
        },
        employee(state) {
            return state.employee
        },
        currentEmployee(state) {
            if (state.currentEmployee == null) return null
            return state.employee.filter(it => it.id === state.currentEmployee)[0]
        }
    },
    mutations: {
        setOrders(state, orders) {
            state.orders = orders
        },
        setStats(state, stats) {
            state.stats = stats
        },
        setGifts(state, gifts) {
            console.log(gifts)
            state.gifts = gifts
        },
        setThanks(state, thanks) {
            state.thanks = thanks
            state.from = thanks
        },
        setThanksOwn(state, thanks) {
            state.thanksOwn = thanks
            state.to = thanks
        },
        setProfile(state, profile) {
            state.from = profile.from
            state.to = profile.to
            state.employee = profile.employee
            state.profile = profile.profile
            state.orders = profile.orders
        },
        selectEmployee(state, employeeId) {
            state.currentEmployee = employeeId
        }
    },
    actions: {
        loadStats(context) {
            axios.post(`${baseUrl}/thanks/stats`, { headers: getHeaders() })
                .then(res => context.commit('setStats', res.data))
        },
        signOut(context) {
            context.state.profile = null
            localStorage.removeItem('phone')
        },
        loadGifts(context) {
            axios.get(`${baseUrl}/thanks/gifts`, { headers: getHeaders() })
                .then(res => context.commit('setGifts', res.data))
        },
        loadThanks(context) {
            context.dispatch('loadStats')
            axios.get(`${baseUrl}/thanks/from/${context.state.profile.id}`, { headers: getHeaders() })
                .then(res => context.commit('setThanks', res.data))
            axios.get(`${baseUrl}/thanks/to/${context.state.profile.id}`, { headers: getHeaders() })
                .then(res => context.commit('setThanksOwn', res.data))
        },
        loadProfile(context) {
            if (localStorage.getItem('phone') === null) {
                router.push('/login')
                return
            }
            axios.get(`${baseUrl}/thanks/profile/${localStorage.getItem('phone')}`, { headers: getHeaders() })
                .then((res) => {
                    return res.data
                })
                .then((res) => {
                    context.commit('setProfile', res)
                    context.dispatch('loadStats')
                    context.dispatch('loadGifts')
                })
                .catch(err => {
                    console.error(err)
                    if (err.response.status === 401) {
                        localStorage.removeItem('phone')
                        router.push('/login')
                    }
                })
        },
        async createThanks(context, thanks) {
            await axios.post(`${baseUrl}/thanks/create`, thanks, { headers: getHeaders() })
            await context.dispatch('loadThanks')
        },
        async createThanksOwn(context, thanks) {
            await axios.post(`${baseUrl}/thanks/create/${thanks.count}`, thanks, { headers: getHeaders() })
            await context.dispatch('loadThanks')
        },
        async sendCode(context, phone) {
            const response = await axios.post(`${baseUrl}/code`, phone, { headers: { 'Content-Type': 'plain/text' }})
            return response.data
        },
        async signIn(context, params) {
            const response = await axios.post(`${baseUrl}/signIn/${params.code}`, params.phone, { headers: { 'Content-Type': 'plain/text' }})
            return response.data
        }
    }
})
import { createMetaManager } from 'vue-meta'

const metaManager = createMetaManager()

createApp(App)
    .use(LoadScript)
    .use(store)
    .use(router)
    .use(metaManager)
    .mount('#app')
